import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-lift',
  templateUrl: './view-lift.component.html',
  styleUrls: ['./view-lift.component.scss'],
})
export class ViewLiftComponent implements OnInit {
  data: any;
  constructor() {}

  ngOnInit() {
    this.data = [
      {
        fromAddress: 'Canberra',
        toAddress: 'Sydney',
        departureDate: '4/29/2019',
        hh: 12,
        mm: 12,
        noOfChild: 2,
        noOfAdults: 1,
        creationDate: '4/29/2019',
        userId: '105',
        userName: 'Sairam',
      },
      {
        fromAddress: 'Sydney',
        toAddress: 'Melbourne',
        departureDate: '4/29/2019',
        hh: 12,
        mm: 12,
        noOfChild: 2,
        noOfAdults: 1,
        creationDate: '4/29/2019',
        userId: '105',
        userName: 'Chintu',
      },
    ];
  }
}
